import { MediaActionType } from '@halo/ui-chat-react';

export interface UseMsgMediaTitleProps {
  type: MediaActionType | undefined;
}

export function useMsgMediaTitle({ type }: UseMsgMediaTitleProps) {
  const { t } = useTranslation();
  const typeStringMap = useMemo(
    () => ({
      [MediaActionType.AUDIO]: t('calls.voiceText'),
      [MediaActionType.VIDEO]: t('calls.videoText'),
    }),
    [t]
  );
  const typeDisplay = useMemo(() => {
    return (type && typeStringMap[type]) || '';
  }, [type, typeStringMap]);

  const title = useMemo(() => {
    if (!typeDisplay) return '';

    return t('calls.callTitle', { type: typeDisplay });
  }, [typeDisplay, t]);

  return {
    typeDisplay,
    title,
  };
}
